import * as React from "react";
import Progress from "./Progress";
import { String } from "aws-sdk/clients/licensemanager";
import SaveEmail from "./SaveEmail";
import { APIUrls, Configs } from "../environments/ConfigDetails";
import qs = require("qs");
import ReactDOM = require("react-dom");
import axios from "axios";
import SignIn from "./SignIn";
import {
  checkAccessTokenIsExpired,
  refreshAccessToken
} from "../service/RefreshToken";

export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
  savedMatters: any[];
  isItemChanged: boolean;
  isLoggedIn: boolean;
}

export interface AppState {
  code: String;
  bucketCredentials;
}

export default class App extends React.Component<AppProps, AppState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      code: "",
      bucketCredentials: null
    };
  }

  componentDidMount() {
    let para = window.location.search;
    let codeVal = "";
    if (para.includes("code")) {
      let paramsArray = para.slice(0).split("&");
      paramsArray.forEach(param => {
        if (param.includes("code")) {
          codeVal = param.split("=")[1];
        }
      });
      this.getAccessToken(codeVal);
    } else if (para.includes("error")) {
      ReactDOM.render(<SignIn />, document.getElementById("container"));
    } else {
      this.getAWSConfigs(null);
    }
  }

  componentWillReceiveProps(_nextProps) {
    this.getAWSConfigs(null);
  }

  render() {
    const { title } = this.props;
    return <Progress title={title} />;
  }

  getAccessToken = code => {
    try {
      if (!this.props.isOfficeInitialized) {
        ReactDOM.render(
          <Progress title={this.props.title} />,
          document.getElementById("container")
        );
      } else if (!this.props.isLoggedIn) {
        let self = this;
        if (code) {
          // retrieve access token using the code
          let settings = Office.context.roamingSettings;
          let codeVerifier = localStorage.getItem("slCodeVerifier");
          let workspaceUrlPrefix =
            typeof settings.get("WorkspaceURLPrefix") !== "undefined"
              ? settings.get("WorkspaceURLPrefix")
            : "eng-outlook";
          let workspaceUrltld =
            typeof settings.get("WorkspaceURLtld") !== "undefined"
              ? settings.get("WorkspaceURLtld")
            : "com";
          axios({
            url: APIUrls.urlForAccessToken(workspaceUrlPrefix, workspaceUrltld),
            method: "post",
            data: qs.stringify({
              grant_type: Configs.grantType,
              code: code,
              redirect_uri: Configs.redirectUri,
              client_id: Configs.clientId,
              code_verifier: codeVerifier
            }),
            headers: {
              "content-type": "application/x-www-form-urlencoded;charset=utf-8"
            }
          })
            .then(response => {
              if (response.status === 200) {
                let result = response.data;
                let accessTokenObj = {
                  access_token: result.access_token,
                  expires_in: result.expires_in,
                  refresh_token: result.refresh_token,
                  scope: result.scope,
                  token_type: result.token_type,
                  date_obtained: new Date()
                };
                // save access token in roaming settings
                let settings = Office.context.roamingSettings;
                settings.set("accessTokenObj", accessTokenObj);
                settings.saveAsync(function(asyncResult) {
                  if (asyncResult.status == Office.AsyncResultStatus.Failed) {
                    // error occurr when saving roaming settings then return to signin page
                    ReactDOM.render(
                      <SignIn />,
                      document.getElementById("container")
                    );
                  } else {
                    // get aws bucket details
                    self.getAWSConfigs(accessTokenObj);
                  }
                });
              } else {
                // response is not successful, return to signin
                ReactDOM.render(
                  <SignIn />,
                  document.getElementById("container")
                );
              }
            })
            .catch(() => {
              ReactDOM.render(
                <SignIn />,
                document.getElementById("container")
              );
            });
        }
      } else {
        this.getAWSConfigs(null);
      }
    } catch (ex) {
      ReactDOM.render(<SignIn />, document.getElementById("container"));
    }
  };

  getAWSConfigs = accessTokenObj => {
    try {
      if (!this.props.isOfficeInitialized) {
        ReactDOM.render(
          <Progress title={this.props.title} />,
          document.getElementById("container")
        );
      } else {
        if (accessTokenObj === null) {
          let settings = Office.context.roamingSettings;
          accessTokenObj = settings.get("accessTokenObj");
        }
        if (typeof accessTokenObj === "undefined") {
          ReactDOM.render(<SignIn />, document.getElementById("container"));
        } else {
          let isExpired = checkAccessTokenIsExpired();
          if (isExpired) {
            let newToken = refreshAccessToken();
            accessTokenObj = newToken;
            if (newToken === null) {
              ReactDOM.render(<SignIn />, document.getElementById("container"));
            }
          }
          if (
            typeof accessTokenObj !== "undefined" &&
            accessTokenObj !== null
          ) {
            let settings = Office.context.roamingSettings;
            let workspaceUrlprefix =
              typeof settings.get("WorkspaceURLPrefix") !== "undefined"
                ? settings.get("WorkspaceURLPrefix")
                : "eng-outlook";
            let workspaceUrltld =
                typeof settings.get("WorkspaceURLtld") !== "undefined"
                  ? settings.get("WorkspaceURLtld")
                  : "com";
            axios
              .get(APIUrls.urlForBucketCredentials(workspaceUrlprefix, workspaceUrltld),
                {
                  headers: {
                    Authorization: "Bearer " + accessTokenObj.access_token
                  }
                }
              )
              .then(response => {
                let credentials = response.data;
                ReactDOM.render(
                  <SaveEmail
                    savedMatters={this.props.savedMatters}
                    isItemChanged={this.props.isItemChanged}
                    bucketCredentials={credentials}
                    isLoggedIn={true}
                  />,
                  document.getElementById("container")
                );
              })
              .catch(() => {
                ReactDOM.render(
                  <SignIn />,
                  document.getElementById("container")
                );
              });
          }
        }
      }
    } catch (ex) {
      ReactDOM.render(<SignIn />, document.getElementById("container"));
    }
  };
}
